import { useQuery } from '@apollo/client';
import { GetReferrerCodeQueryResult } from '@monofront/types';
import { GET_REFERRER_CODE } from '../queries/referrerCode';

type UseReferrerDetails =
  | {
      isLoading: true;
      isError: false;
      referrerCode: undefined;
      referralLink: undefined;
    }
  | {
      isLoading: false;
      isError: true;
      referrerCode: undefined;
      referralLink: undefined;
    }
  | {
      isLoading: false;
      isError: false;
      referrerCode: string;
      referralLink: string;
    };

export const useReferrerDetails = (baseUrl: string): UseReferrerDetails => {
  const {
    data: getReferrerCode,
    loading,
    error,
  } = useQuery<GetReferrerCodeQueryResult>(GET_REFERRER_CODE, {
    ssr: false,
  });

  if (loading) {
    return {
      isLoading: true,
      isError: false,
      referrerCode: undefined,
      referralLink: undefined,
    };
  }

  if (error || !getReferrerCode) {
    return {
      isLoading: false,
      isError: true,
      referrerCode: undefined,
      referralLink: undefined,
    };
  }

  const referrerCode = getReferrerCode.getReferrerCode.referralCode;

  return {
    isLoading: false,
    isError: false,
    referrerCode,
    referralLink: `${baseUrl}/a/refer-a-friend/redeem?referrerCode=${referrerCode}`,
  };
};
